import { ItemsListContainerBase } from '../../../components/items-list-container-base';
import {
    Component,
    OnInit,
    Input,
    Injector,
    ChangeDetectionStrategy,
    ViewEncapsulation,
    Output,
    EventEmitter,
} from '@angular/core';
import { IFormReportQuestion, IFormReportQuestionAnswer } from '../fi-form-report';
import { FiFormHelperService } from '../../../shared/fi-form-shared/fi-form-helper.service';
import { FormQuestionType } from '../../../shared/fi-form-shared/fi-form-enums';
import { FiFormService } from '../../fi-form.service';
import { FiStateNames } from '../../../shared/fi-state-proxy/fi-state-names';

@Component({
    selector: 'fi-form-report-question',
    template: `
        <mat-card class="fi-form-report-card">
          <mat-card-title
            class="BrandedBackgroundColor mat-card-title-text-center-container"
            [class.small]="!isHeaderTextPlaced"
            >
            @if (isHeaderTextPlaced) {
              <!--<div class="fi-form-report-back-button-wrapper">
              <mat-icon (click)="goBack()" class="fi-form-report-back-icon cursor-pointer">
                <span class="fa fa-chevron-left"></span>
              </mat-icon>
              <span (click)="goBack()" class="cursor-pointer">{{'back' | fiAppText}}</span>
            </div>-->
            <span class="fi-form-report-title-text">{{ question.Name }}</span>
            <div class="fi-form-report-additional-item"></div>
          }
        </mat-card-title>
        <mat-card-content class="fi-form-report-print-card">
          @if (!isHeaderTextPlaced) {
            <h3 class="cursor-pointer" (click)="doNavigateToQuestionDetails()">
              {{ question.Name }}
            </h3>
          }
          <div class="list-wrapper">
            <fi-items-list [settings]="ListData" [module]="[FiStateNames.Form._name]"></fi-items-list>
          </div>
          <ng-content></ng-content>
        </mat-card-content>
        </mat-card>
        `,
    styleUrls: ['../fi-form-report.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class FiFormReportQuestionComponent extends ItemsListContainerBase<any> implements OnInit {
    @Input() question: IFormReportQuestion;
    @Input() isHeaderTextPlaced: boolean = false;
    @Input() isScrollable: boolean = false;
    @Output() navigateToQuestionDetails = new EventEmitter<IFormReportQuestion>();
    @Output() back = new EventEmitter();
    @Output() returnAnswerIndexEmitter = new EventEmitter();
    @Output() navigateToSubmissionDetails = new EventEmitter<IFormReportQuestionAnswer>();
    FiStateNames = FiStateNames;

    constructor(
        private injector: Injector,
        private formService: FiFormService,
    ) {
        super();
    }

    ngOnInit() {
        super.onInit(() => this.getListDataInstance(), {
            noLocalSearch: true,
            showDelete: false,
        });
    }

    getListDataInstance() {
        if (this.question.Type === FormQuestionType.Attachment) {
            return this.formService.getFormReportAttachmentQuestionListDataInstance(
                this.injector,
                (data: IFormReportQuestionAnswer) => this.navigateToSubmissionDetails.emit(data),
            );
        } else {
            return this.formService.getFormReportCommonQuestionListDataInstance(
                this.injector,
                (data: IFormReportQuestionAnswer) => {
                    this.isScrollable ? this.returnAnswerIndex(data.AnswerValue) : this.doNavigateToQuestionDetails();
                },
            );
        }
    }

    doNavigateToQuestionDetails() {
        this.navigateToQuestionDetails.emit(this.question);
    }

    returnAnswerIndex(answerValue: string) {
        let answerIndex = this.question.Answers.filter((answer) => answer.AnswerValue).findIndex(
            (answer) => answerValue === answer.AnswerValue,
        );
        this.returnAnswerIndexEmitter.emit(answerIndex);
    }

    goBack() {
        this.back.emit();
    }

    protected LoadItems() {
        this.ListData.Data = this.question.Answers.filter(
            (answer) => answer.AnswerValue || answer.MediaBankFileReferencesCount,
        );
        return Promise.resolve();
    }

    protected SetItemsCount() {
        return Promise.resolve(this.question.Answers.length);
    }
}
